module.exports = __webpack_public_path__ + "static/media/python-expert.2fd9ebe4.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/validations/images/levels/python-expert.png
// module id = 1444
// module chunks = 157